<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import { computed } from "vue"
import { ButtonSize, ButtonType, ButtonVariant } from "./ButtonEnums"

const props = defineProps<{
   size?: ButtonSize
   type?: ButtonType
   variant?: ButtonVariant
   disabled?: boolean
   uppercase?: boolean
   round?: boolean
}>()

const sizeClass = computed(() => ({
   "button--small": props.size === ButtonSize.Small,
   "button--normal": props.size === ButtonSize.Normal,
   "button--large": props.size === ButtonSize.Large
}))

const typeClass = computed(() => ({
   "button--primary": props.type === ButtonType.Primary,
   "button--secondary": props.type === ButtonType.Secondary,
   "button--accent": props.type === ButtonType.Accent,
   "button--link": props.type === ButtonType.Link,
   "button--danger": props.type === ButtonType.Danger
}))

const variantClass = computed(() => ({
   "button--icon": props.variant === ButtonVariant.Icon
}))

const uppercaseClass = computed(() => ({
   "button--uppercase": props.uppercase === true
}))

const disabledClass = computed(() => ({
   "button--disabled": props.disabled === true
}))

const roundClass = computed(() => ({
   "button--round": props.round === true
}))
</script>

<template>
   <button
      :class="[
         'button',
         sizeClass,
         typeClass,
         variantClass,
         uppercaseClass,
         disabledClass,
         roundClass
      ]"
      :disabled="disabled"
   >
      <slot />
   </button>
</template>
